import React, { useState, useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { consentCancelModalData } from '../../data/modalContentData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import Headings from '../../components/Headings'
import Card from '../../components/Card'
import CheckBox from '../../components/CheckBox'
import FooterText from '../../components/PageFooter/FooterText'
import { dataWithAccordion } from '../../data/checkboxData'
import { useNavigate } from 'react-router-dom'
import DirectionLink from '../../components/DirectionLink'
import PageFooter from '../../components/PageFooter'
import PageModal from '../../components/PageModal'

import AccessDataContext from '../../Context'

const Provider = () => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)
  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
  }, [navModalBtnFocused])
  function closeModal() {
    setOpenModal(false)
    setNavModalBtnFocused(true)
  }

  const { accessDataType, addDataToContext, deleteDataFromcCntext } =
    useContext(AccessDataContext)
  function toggleSelectedDataType(title, checked) {
    // bugfix: because checkbox-onClick and onChange trigger same time, so we set !check replace checked in advance here
    if (!checked) {
      addDataToContext(title)
    } else {
      deleteDataFromcCntext(title)
    }
  }

  const accessDataWithFunc = dataWithAccordion.map((item, index) => ({
    ...item,
    toggleChecked: (title, checked) => () =>
      toggleSelectedDataType(title, checked),
  }))

  const pageModalData = {
    isOpen: openModal,
    onClose: () => closeModal(),
    data: {
      ...consentCancelModalData,
      leftButton: 'No',
      leftButtonFunc: () => closeModal(),
      rightButton: 'Yes',
      rightButtonFunc: () => navigate('/cancel-alert'),
      isModalBtn: false,
    },
  }
  const pageFooterData = {
    leftButton: 'Cancel',
    leftButtonFunc: () => setOpenModal(!openModal),
    navModalBtnFocused: navModalBtnFocused,
    rightButton: 'Continue',
    rightButtonFunc: () => navigate('/access-period'),
    isRightButtonDisabled: !accessDataType.length,
    haveShadow: true,
    leftButtonLabel:
      'cancel button, to open the cancel process modal double click here',
    rightButtonLabel: accessDataType.length
      ? 'continue button, to visit next page double click here'
      : 'continue button Disabled, please select at least one of your data cluster to share',
  }
  const footerText = (
    <p>
      We need to collect and use your data for 12 months so we can offer you
      tailored product recommendations that always consider your current
      situation.
    </p>
  )

  return (
    <PageWrapper isModalOpen={pageModalData.isOpen}>
      <Helmet>
        <title>Your data</title>
      </Helmet>
      <PageContentWrapper isModalOpen={pageModalData.isOpen}>
        <DirectionLink
          direction="left"
          link="/provider"
          text="Back"
          isDepenednt={true}
          isFocused={true}
          description="Back button, to visit previous page double click here."
        ></DirectionLink>
        <Headings level="h1" text="Your data"></Headings>
        <Card title="CompareBanks">
          <a
            href="https://www.cdr.gov.au/find-a-provider"
            target="_blank"
            rel="noreferrer"
            title="link to user account number"
            aria-label="link to user account number"
            tabIndex="0"
          >
            ADRBNK00000XY
          </a>
        </Card>
        <FooterText content={footerText} isDepenednt={true} />
        <CheckBox
          title="Select the data we can access"
          data={accessDataWithFunc}
          isAccordionData={true}
        />
      </PageContentWrapper>
      <PageFooter {...pageFooterData} />
      <PageModal {...pageModalData} />
    </PageWrapper>
  )
}

export default Provider
